import { useEffect } from "react";

import { Col, Row } from "react-bootstrap";

import { ActivityFeed } from "./ActivityFeedComponent";
import { ModalFirstLogin } from "./ModalFirstLogin";
import ShortAgenda from "./ShortAgenda";
import { PropsFromReduxDashboard } from "../containers/DashboardContainer";

const Dashboard = ({
  dashboard,
  user,
  getDashboard,
}: PropsFromReduxDashboard) => {
  useEffect(() => {
    getDashboard();
  }, []); //eslint-disable-line

  return (
    <>
      {user && (
        <>
          <ModalFirstLogin isShow={user.isFirstLogin} />
          <div className="dashboard">
            <h1 className="title-dashboard">Tableau de bord</h1>
            <h2 className="welcome-dashboard">Bonjour, {user.firstname} !</h2>
            <div className="dashboard-content">
              <Row>
                <Col xs={12} className="short-agenda-title">
                  <i className="bi bi-calendar3 short-agenda-icon"></i>
                  Mon agenda
                </Col>
              </Row>
              <Row className="short-agenda-content">
                <Col xs={12} className="p-3">
                  {dashboard.services.length !== 0 ? (
                    <ShortAgenda services={dashboard.services} />
                  ) : (
                    <div className="short-agenda-empty">
                      Aucunes commandes dans les trois prochains jours
                    </div>
                  )}
                </Col>
              </Row>

              <Row className="orders-title">
                <Col xs={6} md={12}>
                  <i className="bi bi-cart orders-icon"></i>
                  Mes commandes
                </Col>
              </Row>
              <Row className="orders-content">
                <Col xs={12} md={6}>
                  <div className="orders-content-tile">
                    <div className="orders-content-tile-title">
                      Commandes effectuées :
                    </div>
                    <p className="orders-content-tile-title-data">
                      {dashboard.countServicesDone}
                    </p>
                  </div>
                </Col>
                <Col xs={12} md={6}>
                  <div className="orders-content-tile">
                    <div className="orders-content-tile-title">
                      Commandes à venir :
                    </div>
                    <p className="orders-content-tile-title-data">
                      {dashboard.countServicesIncoming}
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="activity-feed d-none d-md-block">
            <ActivityFeed histories={dashboard.histories} />
          </div>
        </>
      )}
    </>
  );
};
export default Dashboard;
